(() => {
  if (window.AmetistikissaCartBenefitsLoaded) return;
  window.AmetistikissaCartBenefitsLoaded = true;

  const GIFT_VARIANT_ID = 56666961740100;

  const hostname = window.location.hostname.toLowerCase();

const currentLocale = (
  document.documentElement.lang ||
  window.Shopify?.locale ||
  ''
).toLowerCase();

const isEuStore =
  hostname.endsWith('.eu') ||
  currentLocale.startsWith('en');

  /*
   * .EU: 45 € lahja / 120 € ilmainen toimitus
   * .FI: nykyiset 25 € / 60 € rajat
   */
  const BASE_THRESHOLDS = isEuStore
    ? {
        gift: 4500,
        shipping: 12000,
      }
    : {
        gift: 2500,
        shipping: 6000,
      };

  const cartRoot = window.Shopify?.routes?.root || '/';

  function getLanguage() {
  if (isEuStore) return 'en';

  return (
    document.documentElement.lang ||
    window.Shopify?.locale ||
    'fi'
  ).toLowerCase();
}

  function getCopy() {
    if (getLanguage().startsWith('fi')) {
      return {
        updating: 'Päivitetään etuja...',
        giftBefore: (limit) =>
          `🎁 Ilmainen kristalli yli ${limit} tilauksiin`,
        addMore: (amount) =>
          `Lisää vielä <strong>${amount}</strong> 💜`,
        giftAdded: '🎁 Ilmainen kristalli lisätty koriin',
        shippingRemaining: (amount) =>
          `Lisää vielä <strong>${amount}</strong>, niin saat myös ilmaisen toimituksen 🚚`,
        allBenefits:
          '🎁 Saat ilmaisen kristallin ja ilmaisen toimituksen',
        allActive: 'Kaikki edut aktivoitu 💜',
        popupGiftBefore: (limit, amount) =>
          `🎁 Ilmainen kristalli yli ${limit}<br>Lisää vielä <strong>${amount}</strong> 💜`,
        popupGiftAdded: (amount) =>
          `🎁 Ilmainen kristalli lisätty koriin<br>Lisää vielä <strong>${amount}</strong> ilmaiseen toimitukseen 🚚`,
        popupAllActive:
          '🎁 Ilmainen kristalli + ilmainen toimitus aktivoitu 💜',
      };
    }

    return {
      updating: 'Updating your benefits...',
      giftBefore: (limit) =>
        `🎁 Free crystal on orders over ${limit}`,
      addMore: (amount) =>
        `Add <strong>${amount}</strong> more 💜`,
      giftAdded: '🎁 Free crystal added to your cart',
      shippingRemaining: (amount) =>
        `Add <strong>${amount}</strong> more for free shipping 🚚`,
      allBenefits: '🎁 Free crystal and free shipping unlocked',
      allActive: 'All benefits activated 💜',
      popupGiftBefore: (limit, amount) =>
        `🎁 Free crystal on orders over ${limit}<br>Add <strong>${amount}</strong> more 💜`,
      popupGiftAdded: (amount) =>
        `🎁 Free crystal added<br>Add <strong>${amount}</strong> more for free shipping 🚚`,
      popupAllActive:
        '🎁 Free crystal and free shipping unlocked 💜',
    };
  }

  function getCurrencyLocale(currency) {
    if (getLanguage().startsWith('fi')) return 'fi-FI';

    const locales = {
      SEK: 'sv-SE',
      DKK: 'da-DK',
      PLN: 'pl-PL',
      CZK: 'cs-CZ',
      EUR: 'en-IE',
    };

    return locales[currency] || 'en-IE';
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(getCurrencyLocale(currency), {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  }

  function getCurrencyRate(currency) {
    if (currency === 'EUR') return 1;

    const shopifyRate = Number(window.Shopify?.currency?.rate);

    if (Number.isFinite(shopifyRate) && shopifyRate > 0) {
      return shopifyRate;
    }

    /*
     * Turvarajat vain siinä epätodennäköisessä tilanteessa,
     * ettei Shopify.currency.rate ole saatavilla.
     */
    const fallbackRates = {
      SEK: 11.5,
      DKK: 7.5,
    };

    if (fallbackRates[currency]) {
      console.warn(
        `[Cart benefits] Shopify currency rate missing. Using fallback for ${currency}.`
      );

      return fallbackRates[currency];
    }

    console.error(
      `[Cart benefits] Currency conversion rate missing for ${currency}.`
    );

    return 1;
  }

  function convertThreshold(euroCents, currency) {
    const converted = euroCents * getCurrencyRate(currency);

    /*
     * EUR säilyy tarkasti 45/120 eurossa.
     * Muissa valuutoissa raja pyöristetään ylöspäin
     * täyteen kruunuun/zlotyyn jne.
     */
    if (currency === 'EUR') {
      return Math.round(converted);
    }

    return Math.ceil(converted / 100) * 100;
  }

  function getThresholds(cart) {
    const currency =
      cart.currency ||
      window.Shopify?.currency?.active ||
      'EUR';

    return {
      currency,
      gift: convertThreshold(BASE_THRESHOLDS.gift, currency),
      shipping: convertThreshold(
        BASE_THRESHOLDS.shipping,
        currency
      ),
    };
  }

  function isAutomaticGift(item) {
    return (
      Number(item.variant_id) === GIFT_VARIANT_ID &&
      String(item.properties?._auto_gift) === 'true'
    );
  }

  function getQualifyingSubtotal(cart) {
    return (cart.items || []).reduce((sum, item) => {
      if (isAutomaticGift(item)) return sum;

      /*
       * final_line_price huomioi tuotteeseen kohdistuvat
       * alennukset. Lahja ei koskaan kasvata rajaan
       * oikeuttavaa ostoskorisummaa.
       */
      return sum + Number(
        item.final_line_price ??
        item.line_price ??
        item.original_line_price ??
        0
      );
    }, 0);
  }

  async function fetchCart() {
    const response = await fetch(`${cartRoot}cart.js`, {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }

    return response.json();
  }

  function runWhenReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, {
        once: true,
      });
    } else {
      callback();
    }
  }

  class FreeShippingBar {
    constructor() {
  this.lastCart = null;
  this.barObserver = null;
  this.init();
}

    init() {
      this.observeReRenderedBars();
      runWhenReady(() => this.refresh());

      document.addEventListener('cart:refresh', (event) => {
        if (event.detail?.cart) {
          this.updateAllBars(event.detail.cart);
        } else {
          this.refresh();
        }
      });

      document.addEventListener('change', (event) => {
        if (
          event.target.matches('input[name="updates[]"]') ||
          event.target.matches('.quantity__input')
        ) {
          setTimeout(() => this.refresh(), 400);
          setTimeout(() => this.refresh(), 900);
        }
      });

      document.addEventListener('click', (event) => {
        if (
          event.target.closest('button[name="plus"]') ||
          event.target.closest('button[name="minus"]') ||
          event.target.closest('button[type="submit"][name="add"]') ||
          event.target.closest('[name="add"]') ||
          event.target.closest('cart-remove-button')
        ) {
          setTimeout(() => this.refresh(), 400);
          setTimeout(() => this.refresh(), 1000);
        }
      });
    }

    async refresh() {
      try {
        const cart = await fetchCart();
        this.updateAllBars(cart);
      } catch (error) {
        console.error(
          '[Cart benefits] Progress bar update failed:',
          error
        );
      }
    }

    updateAllBars(cart) {
  if (!cart) return;

  /*
   * Säilytetään viimeisin ostoskorin tila.
   * Jos Dawn rakentaa palkin uudelleen, sama tila
   * voidaan palauttaa ilman uutta verkkopyyntöä.
   */
  this.lastCart = cart;

  document
    .querySelectorAll('[data-cart-benefits-bar]')
    .forEach((bar) => this.updateBar(bar, cart));
}
observeReRenderedBars() {
  if (this.barObserver) return;

  runWhenReady(() => {
    this.barObserver = new MutationObserver((mutations) => {
      let newBarAdded = false;

      for (const mutation of mutations) {
        for (const addedNode of mutation.addedNodes) {
          if (!(addedNode instanceof Element)) continue;

          if (
            addedNode.matches('[data-cart-benefits-bar]') ||
            addedNode.querySelector('[data-cart-benefits-bar]')
          ) {
            newBarAdded = true;
            break;
          }
        }

        if (newBarAdded) break;
      }

      /*
       * Päivitetään uudelleen luotu palkki heti viimeisillä
       * tiedoilla. Käyttäjälle ei ehdi näkyä tyhjää tai
       * "Päivitetään etuja..." -tilaa.
       */
      if (newBarAdded && this.lastCart) {
        this.updateAllBars(this.lastCart);
      }
    });

    this.barObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}


    updateBar(bar, cart) {
      const copy = getCopy();
      const thresholds = getThresholds(cart);
      const total = getQualifyingSubtotal(cart);

      const remainingToGift = Math.max(
        thresholds.gift - total,
        0
      );

      const remainingToShipping = Math.max(
        thresholds.shipping - total,
        0
      );

      const progress =
        thresholds.shipping > 0
          ? Math.min(
              (total / thresholds.shipping) * 100,
              100
            )
          : 0;

      const giftPosition =
        thresholds.shipping > 0
          ? (thresholds.gift / thresholds.shipping) * 100
          : 0;

      const textEl = bar.querySelector(
        '[data-free-shipping-text]'
      );

      const subTextEl = bar.querySelector(
        '[data-free-shipping-subtext]'
      );

      const progressEl = bar.querySelector(
        '[data-free-shipping-progress]'
      );

      const giftMilestone = bar.querySelector(
        '[data-gift-milestone]'
      );

      const shippingMilestone = bar.querySelector(
        '[data-shipping-milestone]'
      );

      if (progressEl) {
  const isNewProgressElement =
    progressEl.dataset.progressInitialized !== 'true';

  /*
   * Jos Dawn on juuri luonut progress-elementin uudelleen,
   * asetetaan oikea leveys ilman animaatiota.
   */
  if (isNewProgressElement) {
    progressEl.style.setProperty(
      'transition',
      'none',
      'important'
    );
  }

  progressEl.style.setProperty(
    'width',
    `${progress}%`,
    'important'
  );

  if (isNewProgressElement) {
    /*
     * Pakotetaan selain tallentamaan oikea leveys ennen
     * normaalin animaation palauttamista.
     */
    void progressEl.offsetWidth;

    progressEl.dataset.progressInitialized = 'true';

    requestAnimationFrame(() => {
      progressEl.style.removeProperty('transition');
    });
  }
}

      if (giftMilestone) {
        giftMilestone.style.left = `${giftPosition}%`;
      }

      const giftLabel = formatMoney(
        thresholds.gift,
        thresholds.currency
      );

      const shippingLabel = formatMoney(
        thresholds.shipping,
        thresholds.currency
      );

      this.updateMilestone(
        giftMilestone,
        total >= thresholds.gift,
        '🎁',
        giftLabel
      );

      this.updateMilestone(
        shippingMilestone,
        total >= thresholds.shipping,
        '🚚',
        shippingLabel
      );

      if (!textEl) return;

      textEl.classList.remove(
        'free-shipping-bar__text--success',
        'free-shipping-bar-compact__text--success'
      );

      if (subTextEl) {
        subTextEl.innerHTML = '';
      }

      if (total < thresholds.gift) {
        textEl.innerHTML = copy.giftBefore(giftLabel);

        if (subTextEl) {
          subTextEl.innerHTML = copy.addMore(
            formatMoney(
              remainingToGift,
              thresholds.currency
            )
          );
        }
      } else if (total < thresholds.shipping) {
        textEl.innerHTML = copy.giftAdded;

        if (subTextEl) {
          subTextEl.innerHTML = copy.shippingRemaining(
            formatMoney(
              remainingToShipping,
              thresholds.currency
            )
          );
        }
      } else {
        if (
          textEl.classList.contains(
            'free-shipping-bar-compact__text'
          )
        ) {
          textEl.classList.add(
            'free-shipping-bar-compact__text--success'
          );
        } else {
          textEl.classList.add(
            'free-shipping-bar__text--success'
          );
        }

        textEl.innerHTML = copy.allBenefits;

        if (subTextEl) {
          subTextEl.innerHTML = copy.allActive;
        }
      }

bar.classList.add('is-ready');
    }

    updateMilestone(milestone, active, inactiveIcon, labelText) {
      if (!milestone) return;

      milestone.classList.toggle('is-active', active);

      const dot =
        milestone.querySelector(
          '.free-shipping-bar__milestone-dot'
        ) ||
        milestone.querySelector(
          '.free-shipping-bar-compact__milestone-dot'
        );

      const label =
        milestone.querySelector(
          '.free-shipping-bar__milestone-label'
        ) ||
        milestone.querySelector(
          '.free-shipping-bar-compact__milestone-label'
        );

      if (dot) {
        dot.textContent = active ? '✓' : inactiveIcon;
      }

      if (label) {
        label.textContent = labelText;
      }
    }
  }

  class FloatingFreeShippingPopup {
    constructor() {
      this.popup = document.querySelector(
        '[data-floating-free-shipping-popup]'
      );

      if (!this.popup) return;

      this.textEl = this.popup.querySelector(
        '[data-floating-free-shipping-text]'
      );

      this.progressEl = this.popup.querySelector(
        '[data-floating-free-shipping-progress]'
      );

      this.giftMilestone = this.popup.querySelector(
        '[data-floating-gift-milestone]'
      );

      this.shippingMilestone = this.popup.querySelector(
        '[data-floating-shipping-milestone]'
      );

      this.previousItemCount = null;
      this.hideTimeout = null;

      this.init();
    }

    init() {
      runWhenReady(() => this.refresh(true));

      document.addEventListener('cart:refresh', (event) => {
        if (event.detail?.cart) {
          this.update(event.detail.cart);
        } else {
          this.refresh();
        }
      });

      document.addEventListener('click', (event) => {
        if (
          event.target.closest(
            'button[type="submit"][name="add"]'
          ) ||
          event.target.closest('[name="add"]')
        ) {
          setTimeout(() => this.refresh(), 500);
          setTimeout(() => this.refresh(), 1100);
        }
      });
    }

    async refresh(initial = false) {
      if (window.innerWidth >= 750) return;

      try {
        const cart = await fetchCart();
        this.update(cart, initial);
      } catch (error) {
        console.error(
          '[Cart benefits] Floating popup update failed:',
          error
        );
      }
    }

    update(cart, initial = false) {
      if (window.innerWidth >= 750) return;

      const copy = getCopy();
      const thresholds = getThresholds(cart);
      const total = getQualifyingSubtotal(cart);
      const itemCount = Number(cart.item_count || 0);

      const remainingToGift = Math.max(
        thresholds.gift - total,
        0
      );

      const remainingToShipping = Math.max(
        thresholds.shipping - total,
        0
      );

      const progress =
        thresholds.shipping > 0
          ? Math.min(
              (total / thresholds.shipping) * 100,
              100
            )
          : 0;

      const giftPosition =
        thresholds.shipping > 0
          ? (thresholds.gift / thresholds.shipping) * 100
          : 0;

      if (this.progressEl) {
        this.progressEl.style.width = `${progress}%`;
      }

      if (this.giftMilestone) {
        this.giftMilestone.style.left = `${giftPosition}%`;
      }

      const giftLabel = formatMoney(
        thresholds.gift,
        thresholds.currency
      );

      const shippingLabel = formatMoney(
        thresholds.shipping,
        thresholds.currency
      );

      this.updateMilestone(
        this.giftMilestone,
        total >= thresholds.gift,
        '🎁',
        giftLabel
      );

      this.updateMilestone(
        this.shippingMilestone,
        total >= thresholds.shipping,
        '🚚',
        shippingLabel
      );

      if (this.textEl) {
        if (total < thresholds.gift) {
          this.textEl.innerHTML = copy.popupGiftBefore(
            giftLabel,
            formatMoney(
              remainingToGift,
              thresholds.currency
            )
          );
        } else if (total < thresholds.shipping) {
          this.textEl.innerHTML = copy.popupGiftAdded(
            formatMoney(
              remainingToShipping,
              thresholds.currency
            )
          );
        } else {
          this.textEl.innerHTML = copy.popupAllActive;
        }
      }

      if (initial) {
        this.previousItemCount = itemCount;
        this.hide(true);
        return;
      }

      const countIncreased =
        this.previousItemCount !== null &&
        itemCount > this.previousItemCount;

      if (countIncreased) {
        this.showTemporarily();
      }

      if (itemCount === 0) {
        this.hide(true);
      }

      this.previousItemCount = itemCount;
    }

    updateMilestone(milestone, active, inactiveIcon, labelText) {
      if (!milestone) return;

      milestone.classList.toggle('is-active', active);

      const dot = milestone.querySelector(
        '.floating-free-shipping-popup__milestone-dot'
      );

      const label = milestone.querySelector(
        '.floating-free-shipping-popup__milestone-label'
      );

      if (dot) {
        dot.textContent = active ? '✓' : inactiveIcon;
      }

      if (label) {
        label.textContent = labelText;
      }
    }

    showTemporarily() {
      clearTimeout(this.hideTimeout);

      this.popup.classList.remove('hidden');
      this.popup.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(() => {
        this.popup.classList.add('is-visible');
      });

      this.hideTimeout = setTimeout(() => {
        this.hide();
      }, 3000);
    }

    hide(force = false) {
      clearTimeout(this.hideTimeout);
      this.popup.classList.remove('is-visible');
      this.popup.setAttribute('aria-hidden', 'true');

      if (force) {
        this.popup.classList.add('hidden');
        return;
      }

      setTimeout(() => {
        if (!this.popup.classList.contains('is-visible')) {
          this.popup.classList.add('hidden');
        }
      }, 250);
    }
  }

  class GiftWithPurchase {
    constructor() {
      this.giftVariantId = GIFT_VARIANT_ID;
      this.isUpdating = false;
      this.scheduledSync = null;

      this.sectionIds = [
  'main-cart-items',
  'cart-icon-bubble',
];

      this.init();
    }

    init() {
      runWhenReady(() => this.syncGift());

      document.addEventListener('cart:refresh', (event) => {
        if (event.detail?.source === 'automatic-gift') return;

        this.scheduleSync(100);
      });

      document.addEventListener('change', (event) => {
        if (
          event.target.matches('input[name="updates[]"]') ||
          event.target.matches('.quantity__input')
        ) {
          this.scheduleSync(700);
        }
      });

      document.addEventListener('click', (event) => {
        if (
          event.target.closest('button[name="plus"]') ||
          event.target.closest('button[name="minus"]') ||
          event.target.closest('cart-remove-button') ||
          event.target.closest(
            'button[type="submit"][name="add"]'
          ) ||
          event.target.closest('[name="add"]')
        ) {
          this.scheduleSync(900);
        }
      });
    }

    scheduleSync(delay) {
      clearTimeout(this.scheduledSync);

      this.scheduledSync = setTimeout(() => {
        this.syncGift();
      }, delay);
    }

    async syncGift() {
      if (this.isUpdating) return;

      try {
        const cart = await fetchCart();
        const giftLines = this.findGiftLines(cart);
        const giftLine = giftLines[0] || null;
        const thresholds = getThresholds(cart);
        const subtotal = getQualifyingSubtotal(cart);
        const qualifies = subtotal >= thresholds.gift;

        if (qualifies && !giftLine) {
          await this.addGift();
          return;
        }

        if (!qualifies && giftLines.length) {
          await this.removeAllGiftLines(giftLines);
          return;
        }

        if (giftLine && giftLine.quantity !== 1) {
          await this.setGiftQuantity(giftLine.key, 1);
          return;
        }

        if (giftLines.length > 1) {
          await this.removeDuplicateGiftLines(
            giftLines.slice(1)
          );
        }
      } catch (error) {
        console.error(
          '[Automatic gift] Synchronization failed:',
          error
        );
      }
    }

    findGiftLines(cart) {
      return (cart.items || []).filter((item) =>
        isAutomaticGift(item)
      );
    }

    getSectionRequestData() {
      return {
        sections: this.sectionIds,
        sections_url: window.location.pathname,
      };
    }

    async addGift() {
      this.isUpdating = true;

      try {
        const response = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: this.giftVariantId,
                quantity: 1,
                properties: {
                  _auto_gift: 'true',
                },
              },
            ],
            ...this.getSectionRequestData(),
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description || 'Failed to add gift'
          );
        }

        this.renderSections(data.sections);
        await this.afterGiftChange();
      } finally {
        this.isUpdating = false;
      }
    }

    async removeAllGiftLines(giftLines) {
      this.isUpdating = true;

      try {
        const updates = {};

        giftLines.forEach((line) => {
          updates[line.key] = 0;
        });

        const response = await fetch(
          `${cartRoot}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              updates,
              ...this.getSectionRequestData(),
            }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description || 'Failed to remove gift'
          );
        }

        this.renderSections(data.sections);
        await this.afterGiftChange();
      } finally {
        this.isUpdating = false;
      }
    }

    async removeDuplicateGiftLines(giftLines) {
      return this.removeAllGiftLines(giftLines);
    }

    async setGiftQuantity(lineKey, quantity) {
      this.isUpdating = true;

      try {
        const response = await fetch(
          `${cartRoot}cart/change.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: lineKey,
              quantity,
              ...this.getSectionRequestData(),
            }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
              'Failed to update gift quantity'
          );
        }

        this.renderSections(data.sections);
        await this.afterGiftChange();
      } finally {
        this.isUpdating = false;
      }
    }

   renderSections(sections) {
  if (!sections) return;

  /*
   * Päivitetään vain ostoskorin tuotteet ja korikuvake.
   * main-cart-footer jätetään Dawnin hallintaan, jotta
   * loppusumma ja checkout-painikkeet eivät häviä.
   */

  if (sections['main-cart-items']) {
    const parsedItems = new DOMParser().parseFromString(
      sections['main-cart-items'],
      'text/html'
    );

    const sourceItems = parsedItems.querySelector(
      '#main-cart-items .js-contents'
    );

    const targetItems = document.querySelector(
      '#main-cart-items .js-contents'
    );

    if (sourceItems && targetItems) {
      targetItems.innerHTML = sourceItems.innerHTML;
    }
  }

  if (sections['cart-icon-bubble']) {
    const parsedBubble = new DOMParser().parseFromString(
      sections['cart-icon-bubble'],
      'text/html'
    );

    const sourceBubble = parsedBubble.querySelector(
      '#cart-icon-bubble'
    );

    const targetBubble = document.querySelector(
      '#cart-icon-bubble'
    );

    if (sourceBubble && targetBubble) {
      targetBubble.innerHTML = sourceBubble.innerHTML;
    }
  }
}

    async afterGiftChange() {
      const cart = await fetchCart();

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: {
            cart,
            source: 'automatic-gift',
          },
        })
      );
    }
  }

  window.freeShippingBar = new FreeShippingBar();

  runWhenReady(() => {
    window.floatingFreeShippingPopup =
      new FloatingFreeShippingPopup();

    window.giftWithPurchase = new GiftWithPurchase();
  });
})();